module.exports = ".login-form{\n    min-width: 60%;\n    padding: 20px;\n\n    color: #fafafa;\n    background: -webkit-gradient(linear, left top, right bottom, from(#3f546f), to(#24364E)) !important;\n    background: linear-gradient(to bottom right, #3f546f, #24364E) !important;\n}\n.error-message{\n    color: #fafafa;\n    font-size: 11px;\n}\na{\n    color: #fff;\n}\na:hover{\n    color: #6c7b8b\n}\n.container{\n    height: 80vh;\n}\n.row{\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/guest/new-password/new-password.component.css
// module id = ./src/app/guest/new-password/new-password.component.css
// module chunks = main